<mat-card>
    <form (ngSubmit)="submit()" [formGroup]="orderForm">
        <mat-card-header>
            <mat-card-title>
                <h4>
                    @if (editMode) {
                        <div>
                            <span i18n>Order</span>&nbsp;
                            <span>{{ currentOrderNr }}</span>
                            <span><mat-slide-toggle
                                    formControlName="isInternalOrder">Internal Order</mat-slide-toggle></span>
                        </div>
                    } @else {
                        <span i18n>New Order</span>&nbsp;
                        <span style="padding-left: 20px;"><mat-slide-toggle formControlName="isInternalOrder">Internal Order</mat-slide-toggle></span>
                    }
                </h4>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="order-container">
                <div class="order-meta">


                    <div class="order-meta-form">

                        <div class="row">
                            <div class="column">
                                <mat-form-field class="f-medium">
                                    <mat-label i18n>Vendor</mat-label>
                                    <input #vendorInput [matAutocomplete]="autoVendor" formControlName="vendor" matInput
                                           placeholder="Vendor"
                                           type="text">
                                    <mat-autocomplete #autoVendor="matAutocomplete"
                                                      (optionSelected)="vendorChange($event)"
                                                      [displayWith]="vendorDisplayFn">
                                        @for (vendor of filteredVendors; track vendor) {
                                            <mat-option [value]="vendor">
                                                {{ vendor.name }}
                                            </mat-option>
                                        }
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-form-field class="f-medium">
                                    <mat-label i18n>Primary Contact</mat-label>
                                    <mat-select [compareWith]="comparePeople" formControlName="primaryContact"
                                                i18n-placeholder placeholder="Primary Contact" required>
                                        @for (person of (people | async) ?? []; track person) {
                                            <mat-option [value]="person">
                                                {{ person.name }}&nbsp;
                                                @if (person.emails && person.emails.length > 0) {
                                                    <span
                                                    >&#x3C;{{ person.emails[0].email }}&#x3E;</span>
                                                }
                                            </mat-option>
                                        }
                                    </mat-select>
                                    @if (orderForm.get('primaryContact').hasError('invalidPrimaryContact')) {
                                        <mat-error
                                        >
                                            <ng-container i18n>Please enter a valid Primary Contact</ng-container>
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <mat-form-field class="f-large ml-1">
                                <mat-label i18n>Note to vendor</mat-label>
                  <textarea class="f-tall" formControlName="note" matInput placeholder="Note to vendor"
                            type="text"></textarea>
                            </mat-form-field>
                        </div>


                        <div class="row f-large">
                            <app-user-picker [myControl]="techPersonControl"
                                             placeholder="Select a project manager"></app-user-picker>
                            <mat-form-field class="ml-1 f-large">
                                <mat-label i18n>Note to Project Manager</mat-label>
                  <textarea class="f-tall" formControlName="pmNote" matInput placeholder="Note to Project Manager"
                            type="text"></textarea>
                            </mat-form-field>
                        </div>


                        <div class="row">
                            <mat-form-field class="f-medium">
                                <mat-label i18n>Payment Method</mat-label>
                                <mat-select (selectionChange)="resetHint('payment', $event)"
                                            formControlName="paymentMethod"
                                            placeholder="Payment Method">
                                    @for (pm of paymentMethodOptions; track pm) {
                                        <mat-option [value]="pm.methodValue">
                                            {{ pm.methodValue }}
                                        </mat-option>
                                    }
                                </mat-select>
                                @if (hintPaymentMethod) {
                                    <mat-hint color="warn">Payment hint:
                                        {{ orderForm.get('paymentMethod').value }}
                                    </mat-hint>
                                }
                            </mat-form-field>
                            <mat-form-field class="f-large ml-1">
                                <mat-label i18n>Payment Notes</mat-label>
                  <textarea class="f-tall" formControlName="paymentText" matAutosizeMinRows="3" matInput
                            placeholder="Payment Notes"
                            type="text"></textarea>
                            </mat-form-field>
                        </div>


                        <div class="row">
                            <mat-form-field class="f-medium">
                                <mat-label i18n>Shipping Method</mat-label>
                                <mat-select (selectionChange)="resetHint('shipping', $event)"
                                            formControlName="shippingMethod"
                                            placeholder="Shipping Method">
                                    @for (sm of shippingMethodOptions; track sm) {
                                        <mat-option [value]="sm">
                                            {{ sm }}
                                        </mat-option>
                                    }
                                </mat-select>
                                @if (hintShippingMethod) {
                                    <mat-hint color="warn">Shipping hint:
                                        {{ orderForm.get('shippingMethod').value }}
                                    </mat-hint>
                                }
                            </mat-form-field>
                            <mat-form-field class="f-large ml-1">
                                <mat-label i18n>Shipping Notes</mat-label>
                  <textarea class="f-tall" formControlName="shippingText" matAutosizeMinRows="3" matInput
                            placeholder="Shipping Notes"
                            type="text"></textarea>
                            </mat-form-field>
                        </div>


                        <div class="row">
                            <mat-form-field>
                                <mat-label i18n>Return Method</mat-label>
                  <textarea formControlName="returnMethod" matAutosizeMinRows="3" matInput placeholder="Return Method"
                            type="text"></textarea>
                            </mat-form-field>
                            <mat-form-field class="ml-1">
                                <mat-label i18n>Delivery Date</mat-label>
                                <input matInput [matDatepicker]="deliveryDatePicker" formControlName="deliveryDate"
                                       placeholder="Delivery Date" (click)="deliveryDatePicker.open()">
                                <mat-datepicker-toggle [for]="deliveryDatePicker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #deliveryDatePicker></mat-datepicker>
                                @if (orderForm.get('deliveryDate').hasError('required')) {
                                    <mat-error>
                                        Required field
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field class="ml-1">
                                <mat-label i18n>VAT</mat-label>
                                <mat-select formControlName="vat" placeholder="VAT">
                                    @for (v of vatOptions; track v) {
                                        <mat-option [value]="v">
                                            {{ v }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>


                        <div class="row">
                            <mat-form-field class="f-large">
                                <mat-label i18n>Invoices Free Text</mat-label>
                                <textarea formControlName="invoiceText" matAutosizeMinRows="2" matTextareaAutosize matInput
                                          placeholder="Invoices Free Text"
                                          type="text"></textarea>
                            </mat-form-field>
                            <mat-form-field class="f-large ml-1">
                                <mat-label i18n>Delivery Notes Free Text</mat-label>
                                <textarea formControlName="deliveryText" matAutosizeMinRows="2" matTextareaAutosize matInput
                                          placeholder="Delivery Notes Free Text" type="text"></textarea>
                            </mat-form-field>
                        </div>


                        <div>
                            <p>Order currency:&nbsp;</p>
                            <mat-radio-group>
                                <mat-radio-button (change)="setCurrency('EUR')"
                                                  [checked]="orderForm.get('currency').value === 'EUR'"
                                                  i18n
                                                  type="radio">
                                    EUR
                                </mat-radio-button>&nbsp;&nbsp;
                                <mat-radio-button (change)="setCurrency('USD')"
                                                  [checked]="orderForm.get('currency').value === 'USD'"
                                                  i18n type="radio" value="USD">
                                    USD
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>


                    </div>


                    @if (selectedVendor) {
                        <div class="vendor-info">
                            <div>{{ selectedVendor.name }}</div>
                            <div>
                                <span>{{ selectedVendor.address?.street }}</span>
                            </div>
                            <div>
                                <span>{{ selectedVendor.address?.city }}</span>,&nbsp;
                                <span>{{ selectedVendor.address?.state }}</span>,&nbsp;
                                <span>{{ selectedVendor.address?.postal_code }}</span>
                            </div>
                            <div>
                                <span>{{ selectedVendor.address?.country }}</span>
                            </div>
                            @if (vendorHasNda) {
                                <div>
                                    <a href="{{ndaFile?.webViewLink}}" target="_blank">Open NDA file</a>
                                </div>
                            }
                            @if (vendorNdaFieldIsSet && !vendorHasNda) {
                                <div>
                                    <p class="message">NDA file link is set in the CRM but your user cannot access
                                        it</p>
                                </div>
                            }
                        </div>
                    }
                </div>
                <br/><br/>
                <div class="form-tables-row">
                    <div class="form-items-table">
                        @if (invoiceFormArray.controls.length) {
                            <table>
                                <tr>
                                    <th i18n>Invoice Nr</th>
                                    <th i18n>Invoice Date</th>
                                    <th></th>
                                </tr>
                                @for (invoice of invoiceFormArray.controls; track invoice; let i = $index) {
                                    <tbody
                                            formArrayName="invoices">
                                    <tr [formGroupName]="i">
                                        <td>
                                            <mat-form-field>
                                                <input formControlName="invoiceNr" matInput type="text">
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                                <input [matDatepicker]="inpicker" formControlName="date" matInput>
                                                <mat-datepicker-toggle [for]="inpicker"
                                                                       matSuffix></mat-datepicker-toggle>
                                                <mat-datepicker #inpicker></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <button (click)="removeInvoiceItem(i)" mat-icon-button type="button">
                                                <mat-icon>remove</mat-icon>
                                            </button>
                                            <button (click)="goToFixInvoiceDdt(invoice.value.invoiceNr, invoice.value.date, 'invoices')"
                                                    color="warn"
                                                    i18n
                                                    mat-raised-button>
                                                Fix Invoice
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                }
                            </table>
                        }
                        <!--<button mat-raised-button type="button" (click)="addInvoiceItem()"  [disabled]="!invoiceFormArray.valid" i18n>Add Invoice</button>-->
                    </div>
                    <div class="form-items-table">
                        @if (dNotesFormArray.controls.length) {
                            <table>
                                <tr>
                                    <th i18n>Delivery Note</th>
                                    <th i18n>Delivery Reason</th>
                                    <th i18n>Note Date</th>
                                    <th></th>
                                </tr>
                                @for (deliveryNote of dNotesFormArray.controls; track deliveryNote; let i = $index) {
                                    <tbody
                                            formArrayName="deliveryNotes">
                                    <tr [formGroupName]="i">
                                        <td>
                                            <mat-form-field>
                                                <input formControlName="deliveryNoteNr" matInput type="text">
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                                <input formControlName="reason" matInput type="text">
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                                <input [matDatepicker]="inpicker" formControlName="date" matInput>
                                                <mat-datepicker-toggle [for]="inpicker"
                                                                       matSuffix></mat-datepicker-toggle>
                                                <mat-datepicker #inpicker></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <button (click)="removeDeliveryNoteItem(i)" mat-icon-button type="button">
                                                <mat-icon>remove</mat-icon>
                                            </button>
                                            <button (click)="goToFixInvoiceDdt(deliveryNote.value.deliveryNoteNr, deliveryNote.value.date, 'ddt')"
                                                    color="warn"
                                                    i18n
                                                    mat-raised-button>
                                                Fix Delivery Note
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                }
                            </table>
                        }
                        <!--<button mat-raised-button type="button" (click)="addDeliveryNoteItem()" [disabled]="!dNotesFormArray.valid" i18n>Add Delivery Note</button>-->
                    </div>
                </div>
                <div class="order-entry-array">
                    @if (orderForm.get('vendor').valid) {
                        <app-order-entry-array [currency]="orderForm.get('currency').value"
                                               [itemsFormArray]="itemsFormArray"
                                               formArrayName="items">
                        </app-order-entry-array>
                    }
                </div>
            </div>

            @if (selectedVendor) {
                <div>
                    @if (!vendorHasNda) {
                        <p class="message">Selected vendor has no NDA file attached.</p>
                    }
                    <div>
                        @if (!vendorHasNda) {
                            <mat-checkbox (change)="proceedWithNoNda = $event.checked"
                                          [checked]="proceedWithNoNda">
                                Proceed anyway
                            </mat-checkbox>
                        }
                    </div>
                    <div>
                        @if (!vendorHasNda) {
                            <mat-checkbox (change)="sendReminderEmail = $event.checked"
                                          [checked]="sendReminderEmail">
                                Send reminder email
                            </mat-checkbox>
                        }
                    </div>
                    <div>
                        @if (!vendorHasNda && sendReminderEmail) {
                            <mat-form-field>
                                <mat-label>Send to</mat-label>
                                <mat-select (selectionChange)="setReminderSendTo($event)" [(value)]="reminderSendTo"
                                            multiple>
                                    @for (user of (users$ | async) ?? []; track user) {
                                        <mat-option [value]="user.email">
                                            {{ user.email }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                    </div>
                    @if (!vendorHasNda && sendReminderEmail) {
                        <div class="send-reminder-container">
                            <button (click)="submitReminderEmail()"
                                    [disabled]="reminderSendTo.length === 0 || reminderMailSending || reminderMailSent"
                                    mat-raised-button
                                    type="button">
                                @if (!reminderMailSent) {
                                    <span>Send reminder email</span>
                                }
                                @if (reminderMailSent) {
                                    <span>Reminder email sent</span>
                                }
                            </button>
                            <div class="spinner-container">
                                @if (reminderMailSending) {
                                    <mat-spinner diameter="24"></mat-spinner>
                                }
                            </div>
                        </div>
                    }
                </div>
            }


        </mat-card-content>
        <mat-card-actions>
            @if (!editMode || authorized) {
                <button [disabled]="orderForm.invalid || orderAdding || (!vendorHasNda && !proceedWithNoNda)"
                        mat-raised-button
                        type="submit">
                    @if (editMode) {
                        <span i18n>Update</span>
                    } @else {
                        <span i18n>Submit</span>
                    }
                </button>
            }
            <a [routerLink]="['/order']" mat-raised-button>
                <span i18n>Cancel</span>
            </a>
            @if (editMode) {
                <a [routerLink]="['/order/view', _order.id]" mat-raised-button>
                    <span i18n>View</span>
                </a>
            }
        </mat-card-actions>
    </form>
</mat-card>